import { routes } from '@constants';
import { withFlexProps } from '@hocs';
import { useScreenSize } from '@hooks';
import NoiseWithTapeImage from '@pngs/NoiseWithTape25.png';
import NoiseWithTapeMobile from '@pngs/NoiseWithTapeMobile25.png';
import { Flex, Link, theme, Typography } from '@styles';
import { node, string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { infoPageLayoutByVariant } from './PlatformInfoListPageTemplate.layoutProps';

const PlatformInfoListPageTemplate = ({
  backButtonTitle,
  children,
  pageTitle,
  subtitle,
  updateDate,
}) => {
  const { device, isMobile } = useScreenSize();
  const layout = infoPageLayoutByVariant[device || 'desktop'];

  return (
    <Container
      backgroundImage={isMobile ? NoiseWithTapeMobile : NoiseWithTapeImage}
      backgroundSize="cover"
      flexDirection="column"
      pb={layout?.pb}
      pt={layout?.pt}
      px={layout?.px}
    >
      {backButtonTitle && (
        <Link
          color={theme.colors.schoolBusYellow[100]}
          fontSize={18}
          to={routes.mainPage}
        >
          {'<<'} {backButtonTitle}
        </Link>
      )}
      <Typography
        color={theme.colors.white[100]}
        mb={10}
        mt={10}
        variant={layout?.titleVariant}
      >
        {pageTitle}
      </Typography>
      <Typography
        color={theme.colors.white[100]}
        variant={layout?.subtitleVariant}
        width={isMobile ? '100%' : '50%'}
      >
        {updateDate}
        <br />
        <br />
        {subtitle}
      </Typography>
      {children}
    </Container>
  );
};

const Container = styled(Flex)`
  background-blend-mode: overlay;
  overscroll-behavior: contain;
`;

PlatformInfoListPageTemplate.propTypes = {
  backButtonTitle: string.isRequired,
  children: node.isRequired,
  pageTitle: string.isRequired,
  subtitle: string.isRequired,
  updateDate: string.isRequired,
};

export default withFlexProps(PlatformInfoListPageTemplate);
